import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import { ResponseStatuses } from '@/enums';
import PollsGetters from './getters';
import PollsMutations from './mutations';
import PollsState from './state';
import { PollsService } from '../services';

const pollsService = new PollsService();

export default class PollsActions extends Actions<
PollsState,
PollsGetters,
  PollsMutations,
  // eslint-disable-next-line no-use-before-define
  PollsActions
> {
  async get_polls() {
    try {
      const { sortBy = [], sortDesc = [] } = this.state.table_options;
      const { current_page, limit } = this.state.pagination_props;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit,
          page: current_page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      const { data, meta } = await pollsService.get_polls(payload);

      this.mutations.SET_POLLS(data.items);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    }
  }

  async get_poll_by_id(id: string | number) {
    this.mutations.TOGGLE_STEPPER_LOADING(true);
    this.mutations.CLEAR_POLL();

    try {
      const { data } = await pollsService.get_poll_by_id(id);

      this.mutations.SET_CURRENT_POLL(data);
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_STEPPER_LOADING(false);
    }
  }

  async send_result(id: string | number) {
    try {
      const payload = {
        start_time: this.state.start_time || '2024-05-18 12:15:00',
        has_sent: this.state.has_sent,
        questions: this.state.questions,
      };

      const code = await pollsService.send_result(id, payload);

      if (code === ResponseStatuses.Success.CREATED && this.state.has_sent) {
        this.mutations.TOGGLE_SUCCESS_DIALOG(true);
      }
    } catch (error) {
      console.log(error);
    }
  }
}
